export const cssVariables = {
	//синий
	colorPrimary: "rgb(99, 102, 241)",
	//светло-серый
	colorSecondary: "#5f5f5f",
	//Пример:Кнопка отмены
	ordinaryTextColor: "#494949",
	//цвет заголовков
	headerColor: "#3E3D3D",
	//цвет подзаголовков
	subtitleColor: "#1F1F1F",
	/** ошибка */
	errorText: "#c41b1b"
}